import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";

const FIELDS = ["原本狀態", "做了什麼", "發生什麼不同", "學員真實回饋"];

export default function TestimonialSection() {
  return (
    <section className="bg-white">
      <div className="mx-auto max-w-container px-4 md:px-6 py-14 md:py-20 lg:py-24">
        <Reveal>
          <SectionHeading
            eyebrow="學員成果與回饋"
            title="真正重要的，不是聽懂多少，而是生活開始有什麼不同。"
            align="center"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {[0, 1, 2].map((i) => (
            <Reveal key={i} delay={i * 90}>
              <div className="h-full rounded-card bg-cream border border-line p-7">
                <div className="flex items-center justify-between">
                  <span className="inline-flex items-center rounded-full bg-gold-soft/60 px-3 py-1 text-xs font-medium text-primary">
                    案例待補
                  </span>
                  <i className="ri-double-quotes-r text-2xl text-gold" aria-hidden="true"></i>
                </div>
                <div className="mt-6 space-y-4">
                  {FIELDS.map((f) => (
                    <div key={f}>
                      <p className="text-xs font-semibold text-ink-soft/70">{f}</p>
                      <p className="mt-1 text-sm text-ink-soft/50">內容建置中</p>
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={140}>
          <p className="mt-8 text-center text-xs text-ink-soft/60">
            真實學員回饋待業主提供後補上
          </p>
        </Reveal>
      </div>
    </section>
  );
}